import cx from 'classnames';
import PropTypes from 'prop-types';
import {Button} from './Button';
import {Typography} from './Typography';

export const Radio = ({
  onChange,
  className,
  label,
  id,
  'data-qa-id': dataQaId,
  checked,
  disabled,
  ariaLabel = null,
}) => {
  const wrapperClasses = cx('radio-wrapper', className);
  const radioClasses = cx('radio', {'checked-radio': checked, disabled});

  return (
    <Button
      variant="transparent"
      className={wrapperClasses}
      disabled={disabled}
      onClick={onChange}
      id={id}
      data-qa-id={dataQaId}
      data-qa-value={typeof checked === 'boolean' ? checked.toString() : checked}
      ariaLabel={ariaLabel || undefined}
    >
      <div className={radioClasses}>{checked && <div className="checked" />}</div>
      <Typography
        className="radio-label"
        as="label"
        htmlFor={id}
        variant="paragraph2"
        color={disabled ? 'cloud' : 'charcoal'}
      >
        {label}
      </Typography>
    </Button>
  );
};

Radio.propTypes = {
  onChange: PropTypes.func.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  id: PropTypes.string,
  'data-qa-id': PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
};
